module.exports = __webpack_public_path__ + "static/media/box-alt-light.41671982.svg";